import { IApplicationState } from '../../../types/types';
import { TActivity } from '../types';

export const getActivities = (
    state: IApplicationState,
): TActivity[] => {
    return state.activities && Object.values(state.activities);
}
